/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable react/prop-types */

import React from "react";
import Article from "../../../../entities/article";
import Labels from "../../../../components/ArticleBox/pc/components/Labels";
import ArticleBoxThumbnail from "../../../../components/ArticleBoxThumbnail";

function CompanyPCArticleBox({ article, company_name, company_name_ja }) {
  const imageUrl = article.medium_pic_url;
  const userIconUrl = article.user?.icon_url;
  const showingUserIconFallback =
    !article.medium_pic_url && article.user?.icon_url;

  return (
    <div
      className={`${
        article.pickup ? "jsPickupArticle" : "jsArticleWithoutPickup"
      }`}
    >
      <article
        className={`resultBox jsResultBox isWideInside jsArticle${article.id} ${
          article.pickup ? "pickup" : ""
        }`}
      >
        <div className="infoBox">
          <a href={article.companies_path(company_name)}>
            <div className="resultBoxInline">
              <div
                className={`resultBoxTop ${
                  showingUserIconFallback ? "showingUserIcon" : ""
                }`}
              >
                <ArticleBoxThumbnail
                  imageUrl={imageUrl}
                  userIconUrl={userIconUrl}
                  effect="opacity"
                  showUserIconBackground={false}
                />
              </div>
              <div className="resultBoxBottom">
                <div>
                  <Labels key={article.id} article={article} />
                </div>
                <h3>{article.title}</h3>
                <div className="isUserName">{article.user_name()}</div>
                <ul className="resultElements hasWidth">
                  {Article.category_labels().map(
                    (cat) =>
                      article[cat] && (
                        <li key={cat}>
                          <div
                            key={cat}
                            className={`p_icon ${Article.class_name(
                              cat
                            )} resultElementsItem`}
                          />
                          <div
                            className="itemText"
                            dangerouslySetInnerHTML={{
                              __html: article.category_names(cat),
                            }}
                          />
                        </li>
                      )
                  )}
                </ul>
              </div>
            </div>
            {article.description && (
              <p className="js2LinesLimitBottom resultDesc">
                {article.description}
              </p>
            )}
            <div
              className="p_bookmarkIconBtn jsBookmark"
              data-id={`${article.id}`}
            >
              <button
                type="button"
                className="bookmarkAdd"
                onClick={(e) => addCookieBookmark(e, article.id)}
              >
                {" "}
              </button>
              <button
                type="button"
                className="bookmarkRemove"
                onClick={(e) => deleteCookieBookmark(e, article.id)}
              >
                {" "}
              </button>
            </div>
          </a>
        </div>
      </article>
      {article.pickup && article.pickup.comment && (
        <div className="pickupSpeechBubble">
          <h3 className="pickupSpeechBubbleHeading">PICKUP COMMENT</h3>
          <p className="pickupSpeechBubbleSubHeading">
            {article.pickup.comment}
          </p>
          <div className="pickupSpeechBubbleCompanyName">
            編集：
            {article.pickup.is_pickup_by_activo
              ? "株式会社activo(ボランティアポータル委託先)"
              : company_name_ja}
            担当者
          </div>
        </div>
      )}
    </div>
  );
}

export default CompanyPCArticleBox;
